import { render, staticRenderFns } from "./ThemeFormPublic.vue?vue&type=template&id=472d6ae2"
import script from "./ThemeFormPublic.vue?vue&type=script&lang=js"
export * from "./ThemeFormPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports